/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextInput, Loading, FormGroup, Button, TextArea, TextInputSkeleton, DatePickerSkeleton } from 'carbon-components-react';
import '../../../../scss/custom.scss';
import Save16 from '@carbon/icons-react/lib/save/16';
import {
  CheckmarkOutline16,
  Information16,
} from '@carbon/icons-react/lib/';
import SimpleReactValidator from 'simple-react-validator';
import { v4 as uuid } from 'uuid';
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import { getError, getSuccess, entitiesLabels, apioperation, DateFormat } from '../../../../helpers/Constants';
import { api } from '../../../../helpers/api/api';
import { IsEditable, CanExecuteAction } from '../../../../helpers/authorization/Policies';
import { AppContext } from '../../../../helpers/context/AppContext';
import PageBreadCrumb from '../../../../helpers/PageBreadCrumb';
import { switchDateFormat } from '../../../../helpers/jsonschemaform/customwidget/utils';
import { WFActionModal } from '../../../common/WFActionModal';
import { HistoryTable } from '../../../../helpers/HistoryTable';
import DrillRepository from '../../../../helpers/api/DrillRepository';
import DateTimePicker from '../../../../helpers/DateTimePicker';
import AttachmentTable from '../../../common/AttachmentTable';


export default class DrillCARDetail extends Component {
  baseUrl;

  constructor(props) {
    super(props);

    // const idDrillEdit = props ? props.match.params.id : '';
    const idCar = props ? props.match.params.idCar : '';
    // const idAnswer = props ? props.match.params.idAnswer : '';
    this.validator = new SimpleReactValidator();
    this.state = {
      isSubmitted: false,
      // idDrillEdit,
      idCar,
      // idAnswer,
      isLoading: true,
      model: null,

      // /Status Action
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      // approvalStartDate: null,
      // approvalEndDate: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      // selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      // /Status Action
      isHistoryModalOpen: false,
    };
    this.baseUrl = `/drill/report/answer/car/${this.state.idCar}`;

    this.onCauseofInefficiencyChange = this.onCauseofInefficiencyChange.bind(this);
    this.onCorrectiveActionChange = this.onCorrectiveActionChange.bind(this);
    this.onImmediateTreatmentChange = this.onImmediateTreatmentChange.bind(this);
  }

  componentDidMount() {
    this.getCAR();
  }

  getCAR = () => {
    this.setState({
      isLoading: true,
    });

    api
      .getAll(this.baseUrl)
      .then((response) => {
        const { data } = response;
        if (data) {
          this.setState({
            // model: data,
            model: {
              ...data,
              drillReport: data.drillCheckListRequirementAnswer.drillReport
                ? data.drillCheckListRequirementAnswer.drillReport
                : data.drillReport,
            },
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`, 'CAR not found');
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.GET));
        this.props.history.push(this.baseUrl);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  updateCar = async () => {
    if (this.validator.allValid()) {
      try {
        this.setState({ isSubmitted: true });
        await api.put(this.baseUrl, this.state.model);
        showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.CAR, apioperation.PUT));

        await DrillRepository.updateCachedCarList(this.state.model);
      } catch (error) {
        // showNotification.error(getError(entitiesLabels.CAR, apioperation.PUT));
      } finally {
        this.setState({ isSubmitted: false });
      }
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,
        `${entitiesLabels.EMERGENCYDRILL_CAR} required fields are missing  `
      );
      this.forceUpdate();
    }
  };

  showButtonHistory = () => (
    <Button
      className="action-button-modal"
      kind="secondary"
      renderIcon={Information16}
      onClick={() => this.openModalHistory()}
    >
      History
    </Button>
  );

  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };

  showLoading() {
    const show = this.state.isLoading || this.state.isSubmitted;
    const descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active withOverlay description={descr} />;
    // return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  onImmediateTreatmentChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => ({ model: {
        ...prevState.model,
        immediateTreatment: value,
      } }));
  }

  onCauseofInefficiencyChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => ({
      model: {
        ...prevState.model,
        causeOfInefficiency: value,
      },
    }));
  }

  onCorrectiveActionChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => ({
      model: {
        ...prevState.model,
        correctiveAction: value,
      },
    }));
  }

  IsRowSelectable() {
    const row = this.state.model;
    if (row == null) return false;
    return true;
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
  ) {
    this.setState({
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      withApprover,
      // selectedData: selectedRows,
      approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired,
    });
  }

  getStatusActions = (user) => {
    if (!this.IsRowSelectable()) return null;

    let emailOwner = null;
    if (this.state.model != null) {
      if (this.state.model.owner != null) {
        emailOwner = this.state.model.owner.email;
      } else if (this.state.model.ownerSaipem != null) {
        emailOwner = this.state.model.ownerSaipem.email;
      } else {
        emailOwner = '';
      }
    }

    const canEditResource = this.state.model && {
      idCompiler: this.state.model.drillReport.idCompiler,
      email: emailOwner
    };

    const { idStatus } = this.state.model;
    return (
      <>
        {CanExecuteAction(
          'Emergency Drill',
          'CARSimplified',
          user,
          idStatus,
          'Close',
          canEditResource
        ) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() => { this.updateCar(); this.batchActionClick('Close', 'Close', null, false, true, null); }}
          >
            Close CAR
          </Button>
        ) : null}

        {CanExecuteAction(
          'Emergency Drill',
          'CARSimplified',
          user,
          idStatus,
          'Open',
          canEditResource
        ) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() => this.batchActionClick('Open', 'Open', null, false, true, null)}
          >
            Open CAR
          </Button>
        ) : null}
      </>
    );
  };

  // WF
  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: [this.state.idCar],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    if (this.state.model.correctiveAction == null && this.state.model.idStatus !== 4) {
      this.setState({
        isApprovalModalOpen: false,
      });
      showNotification.warning(`${entitiesLabels.WARNING}`, 'Corrective Action required field is missing');
    } else {
      this.setState({
        isLoadingWFOperation: true,
      });
      api
        .put(`/drill/report/${this.state.model.drillReport.id}/car/${apiEndpoint}`, data, '')
        .then((response) => {
          if (response.status === 200) {
            showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.CAR, apioperation.PUT));
            this.setState({
              isLoadingWFOperation: false,
              isApprovalModalOpen: false,
              isLoading: true,
              // model: null
            });
            this.getCAR();
          } else {
            showNotification.error();
            this.setState({
              isLoadingWFOperation: false,
            });
          }
        })
        .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.PUT));
          this.setState({
            isLoadingWFOperation: false,
          });
        })
        .finally(() => {});
    }
  };

  getUrlBack = () => {
    if (this.state.model?.drillReport?.id != null) {
      this.props.history.goBack();
    }
  };

  updateActualCompletitionDate = (_, completationDate) => {
    this.setState((prevState) => 
      ({ model: { ...prevState.model, actualDateCompletition: completationDate } }));
  } 

  clearAttachment = () => ({
    id: null, // guid
    fileIdentifier: null,
    name: null,
    contentType: null,
    size: null,
    type: null,
  });

  onUploadFiles = (fileIdentifier, fileName, fileType, size) => {
    const attachment = { ...this.state.attachment };

    attachment.id = uuid();
    attachment.fileIdentifier = fileIdentifier.blobName;
    attachment.name = fileName;
    attachment.contentType = fileType;
    attachment.size = size;
    // attachment.filePath = file.localPath;

    this.setState({
      attachment: this.clearAttachment(),
    });

    try {
      if (attachment == null) return;
      // insert
      //RITM0994510 RITM0983788 - EM Drill Upload CAR
      // this.setState((prevState) => {
      //   const oldattachment = prevState.attachment || [];

      //   const newItem = {
      //     id: uuid(), // guid

      //     idAttachment: attachment.id, // guid
      //     attachment,
      //   };

        // const newattachment = oldattachment.concat([newItem]);
        // return { model: { ...prevState.model, attachment: newattachment } };
      //});
      const oldattachment = this.state.model.attachment || [];

      const newItem = {
        id: uuid(), // guid

        idAttachment: attachment.id, // guid
        attachment,
      };

      const newattachment = oldattachment.concat([newItem]);
      this.setState((prevState) => ({ model: { ...prevState.model, attachment: newattachment } }));
      //End
    } catch (error) {
      showNotification.error();
    }
  };

  onRemoveFile = (id) => {
    if (!id) return;
    this.setState((prevState) => {
      const statusCopy = { ...prevState.model };
      statusCopy.attachment = statusCopy.attachment.filter((el) => el.id !== id);
      return { model: statusCopy };
    });
  };


  render() {
    let emailOwner = null;
    if (this.state.model != null) {
      if (this.state.model.owner != null) {
        emailOwner = this.state.model.owner.email;
      } else if (this.state.model.ownerSaipem != null) {
        emailOwner = this.state.model.ownerSaipem.email;
      } else {
        emailOwner = '';
      }
    }

    const canEditResource = this.state.model && {
      idCompiler: this.state.model.drillReport.idCompiler,
      idDataApprover: this.state.model.drillReport.idDataApprover,
      idDivisionManager: this.state.model.drillReport.idDivisionManager,
      email: emailOwner
    };
    const validations = {
      correctiveAction: this.validator.message(
        'Corrective Action',
        this.state.model?.correctiveAction,
        'required'
      ),
    };
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo={`/drill/report/${this.state.model?.drillReport.id}/car`}
              linkText="CAR List"
              titleLeft={`Drill Id: ${
                (this.state.model && this.state.model.drillReport.drillReportCode) || ''
              } - CAR Detail`}
              titleCenter={this.state.model && `ID: ${this.state.model.drillCARCode}`}
              titleRight={
                this.state.model && this.state.model.status
                  ? this.state.model.status?.carSimplifiedName
                  : null
              }
              batchActions={this.getStatusActions(user, canEditResource)}
              showButtonHistory={this.showButtonHistory()}
              // onClick={this.getUrlBack}
            />
            <div className="mainContainer">
              {this.showLoading()}
              <WFActionModal
                show={this.state.isApprovalModalOpen}
                title={`${this.state.approvalModalAction} Drill CAR`}
                action={this.state.approvalModalAction}
                withApprover={this.state.withApprover}
                approver={this.state.approver}
                approverRole={this.state.approverRole}
                approverOptions={this.state.approvers}
                isLoadingOperation={this.state.isLoadingWFOperation}
                onApproverSelect={this.handleApproverSelect}
                isLoadingOptions={this.state.isLoadingApproverOptions}
                onCancel={this.handleCloseApprovalModal}
                onConfirm={this.handleConfirmApprovalModal}
                onApprovalNotesChange={this.handleApprovalNotesChange}
                approvalNotes={this.state.approvalNotes}
                approvalNotesRequired={this.state.approvalNotesRequired}
                validationMessages={this.state.approvalValidationMessages}
              />
              <HistoryTable
                entityId={this.state.idCar}
                isOpenModal={this.state.isHistoryModalOpen}
                onClose={() => this.closeModalHistory()}
              />
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  {this.state.model && (
                    <div className="bx--row">
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="CAR Owner">
                          <TextInput
                            id="txt-name"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={
                              this.state.model.owner
                                ? `${this.state.model.owner.name} ${this.state.model.owner.surname}`
                                : `${this.state.model.ownerSaipem.name} ${this.state.model.ownerSaipem.surname}`
                            }
                            disabled
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="CAR Owner Email">
                          <TextInput
                            id="txt-email"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={
                              this.state.model.owner != null
                                ? this.state.model.owner.email
                                : this.state.model.ownerSaipem.email
                            }
                            disabled
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="Due Date">
                          <TextInput
                            id="dueDate1"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={switchDateFormat(this.state.model.dueDate, 'date')}
                            disabled
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="Status">
                          <TextInput
                            key={`status_${this.state.model.status.carSimplifiedName}`}
                            id="status"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={
                              this.state.model.status && this.state.model.status.carSimplifiedName
                            }
                            disabled
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-6 bx--col-lg-6">
                        <FormGroup legendText="Actual date of completion of CA">
                          {!this.state.model ? (
                            <TextInputSkeleton hideLabel />
                          ) : (
                            <div className="bx--col-md-6 bx--col-lg-6 pl-0">
                              {!this.state.model ? (
                                <DatePickerSkeleton />
                              ) : (
                                <DateTimePicker
                                  value={this.state.model?.actualDateCompletition}
                                  type="date"
                                  disableFutureDate
                                  placeholder={DateFormat}
                                  name="actualDateCompletition"
                                  alt="model"
                                  id="actualDateCompletition"
                                  onChange={this.updateActualCompletitionDate}
                                  disabled={!IsEditable(
                                    'Emergency Drill',
                                    'CARSimplified',
                                    user,
                                    this.state.model ? this.state.model.idStatus : null,
                                    'ActualDateCompletition',
                                    canEditResource
                                  )}
                                />
                            )}
                            </div>
                          )}
                        </FormGroup>
                      </div>
                      <div className="bx--col-lg-12 bx--col-md-12">
                        <FormGroup legendText="Finding Description*">
                          <TextArea
                            maxLength={5000}
                            labelText=""
                            id="inputFindingDescription"
                            name="inputfindingdescription"
                            cols={250}
                            disabled
                            invalid={false}
                            invalidText="required"
                            light
                            placeholder=""
                            rows={5}
                            defaultValue={this.state.model.findingDescription || ''}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-lg-12 bx--col-md-12">
                        <FormGroup legendText="Details Of Inefficiency">
                          <TextArea
                            maxLength={5000}
                            labelText=""
                            id="inputDetailOfInefficiency"
                            name="inputdetailsofinefficiency"
                            cols={250}
                            disabled
                            invalid={false}
                            invalidText="required"
                            light
                            placeholder=""
                            rows={5}
                            defaultValue={this.state.model.detailsOfInefficiency || ''}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-lg-12 bx--col-md-12">
                        <FormGroup legendText="Corrective Action to be implemented/Recommended action*">
                          <TextArea
                            maxLength={5000}
                            labelText=""
                            id="inputIdentifiedCorrectiveAction"
                            name="inputindentifiedcorrectiveaction"
                            cols={250}
                            disabled
                            invalid={false}
                            invalidText="required"
                            light
                            placeholder=""
                            rows={5}
                            defaultValue={this.state.model.identifiedCorrectiveAction || ''}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-lg-12 bx--col-md-12">
                        <FormGroup legendText="Immediate Treatment">
                          <TextArea
                            maxLength={5000}
                            labelText=""
                            id="inputimmediateTreatment"
                            name="inputimmediateTreatment"
                            cols={250}
                            disabled={
                              !IsEditable(
                                'Emergency Drill',
                                'CARSimplified',
                                user,
                                this.state.model ? this.state.model.idStatus : null,
                                'ImmediateTreatment',
                                canEditResource
                              )
                            }
                            invalid={false}
                            invalidText="required"
                            light
                            placeholder=""
                            rows={5}
                            value={this.state.model.immediateTreatment || ''}
                            onChange={this.onImmediateTreatmentChange}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-lg-12 bx--col-md-12">
                        <FormGroup legendText="Cause of Inefficiency">
                          <TextArea
                            maxLength={5000}
                            labelText=""
                            id="inputCauseOfInefficiency"
                            name="inputCauseOfInefficiency"
                            cols={250}
                            disabled={
                              !IsEditable(
                                'Emergency Drill',
                                'CARSimplified',
                                user,
                                this.state.model ? this.state.model.idStatus : null,
                                'CauseOfInefficiency',
                                canEditResource
                              )
                            }
                            invalid={false}
                            invalidText="required"
                            light
                            placeholder=""
                            rows={5}
                            value={this.state.model.causeOfInefficiency || ''}
                            onChange={this.onCauseofInefficiencyChange}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-lg-12 bx--col-md-12">
                        <FormGroup legendText="Corrective Action*">
                          <TextArea
                            maxLength={5000}
                            labelText=""
                            id="inputCorrectiveAction"
                            name="inputCorrectiveAction"
                            cols={250}
                            disabled={
                              !IsEditable(
                                'Emergency Drill',
                                'CARSimplified',
                                user,
                                this.state.model ? this.state.model.idStatus : null,
                                'CorrectiveAction',
                                canEditResource
                              )
                            }
                            invalid={validations.correctiveAction}
                            invalidText={validations.correctiveAction}
                            light
                            placeholder=""
                            rows={5}
                            value={this.state.model.correctiveAction || ''}
                            onChange={this.onCorrectiveActionChange}
                          />
                        </FormGroup>
                      </div>

                      <AttachmentTable
                        storagePath="drill"
                        model={this.state.model}
                        items={this.state.model?.attachment}
                        apiDownloadUrl={`/drill/car/${this.state.idCar}/attachment/`}
                        onUploadFIle={this.onUploadFiles}
                        onDeleteFile={this.onRemoveFile}
                        isDisabled={!IsEditable(
                          'Emergency Drill',
                          'CARSimplified',
                          user,
                          this.state.model ? this.state.model.idStatus : null,
                          'Attachments',
                          canEditResource
                        )}
                      />


                      {IsEditable(
                        'Emergency Drill',
                        'CARSimplified',
                        user,
                        this.state.model ? this.state.model.idStatus : null,
                        'CorrectiveAction',
                        canEditResource
                      ) && (
                        <div className="bx--col-lg-12 bx--col-md-12 main-information-button">
                          <Button
                            size="default"
                            renderIcon={Save16}
                            kind="primary"
                            onClick={this.updateCar}
                            disabled={this.state.isSubmitted || this.state.editingDisabled}
                          >
                            Save
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}

DrillCARDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      idCar: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    length: PropTypes.number,
    action: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      hash: PropTypes.string,
      state: PropTypes.object
    }),
    index: PropTypes.number,
    entries: PropTypes.array,
    createHref: PropTypes.func,
    push: PropTypes.func,
    replace: PropTypes.func,
    go: PropTypes.func,
    goBack: PropTypes.func,
    goForward: PropTypes.func,
    canGo: PropTypes.func,
    block: PropTypes.func,
    listen: PropTypes.func
  }).isRequired,
};
